import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { transportReport_transportReport_edges_node } from "../../types/transportReport";
import OrderLinesList from "../TransportReportList";
import {
  createFilterStructure,
  OrderLinesFilterKeys,
  OrderLinesListFilterOpts
} from "./filters";

interface OrderLinesListPageProp
  extends ListProps,
    FilterPageProps<OrderLinesFilterKeys, OrderLinesListFilterOpts>,
    TabPageProps {
  transportReport: transportReport_transportReport_edges_node[];
  onBack: () => void;
  download: () => void;
}

const TransportReportListPage: React.FC<OrderLinesListPageProp> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  transportReport,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Transport Report">
          <Button
            color="primary"
            variant="contained"
            disabled={!transportReport}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Rider First or Last Name"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <OrderLinesList transportReport={transportReport} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default TransportReportListPage;
